export default __webpack_public_path__ + "static/media/logo-app2l.7e180335.svg";